import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import Navbar from "../../components/parts/navbar/Navbar";
import TopLinks from "../../components/parts/TopLinks/TopLinks";
import Menu from "../../components/parts/menu/Menu";
import Footer from "../../components/parts/footer/Footer";
import BannerMarcas from "./bannerMarcas/BannerMarcas";
import ProdutosMarcas from "./produtosMarcas/ProdutosMarcas";
import BTNtoTop from "../../components/parts/BTNtoTop/BTNtoTop";

export default function Marcas() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [marcaData, setMarcaData] = useState(null);

  const navigate = useNavigate();

  const { nome } = useParams();
console.log("nome",nome)
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    async function fetchMarca() {
      try {
        const response = await fetch(
          "https://app.eliandroalimentos.com.br/api/marcaspage/listar",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ nome }),
          }
        );

        const data = await response.json();
console.log("data",data)

 // Se vier vazio, redireciona
        if (!data || data.length === 0) {
          navigate(`/busca/${nome}`);
          return;
        }

        // API retorna um array
        if (data && data.length > 0) {
          setMarcaData(data[0]);
        }
      } catch (error) {
        console.error("Erro ao buscar marca:", error);
      }
    }

    if (nome) {
      fetchMarca();
    }
  }, [nome]);

  return (
    <>
      <Navbar />
      <TopLinks onOpenMenu={() => setMenuOpen(true)} />
      <Menu isOpen={menuOpen} onClose={() => setMenuOpen(false)} />

      <div className="categori-link-left">
        <a href="/" className="breadcrumb-link">Início</a>
        <span className="breadcrumb-separator">›</span>
        <div className="breadcrumb-current">Marcas</div>
      </div>

      {/* Banner */}
      <BannerMarcas dados={marcaData} />

      {/* Produtos */}
      <div className="categoria-wrapper">
        <ProdutosMarcas dados={marcaData} />
      </div>

      <BTNtoTop />
      <Footer />
    </>
  );
}
